<template>
  <footer class="page-footer">
    colin-lankau.com
  </footer>
</template>

<style scoped>
.page-footer {
  background: #E8E8E8;
  border-top: 2px solid #CCCCCC;
  padding: 15px;
  text-align: center;
  color: #666666;
  font-size: 12px;
}
</style>
